// extracted by mini-css-extract-plugin
export default {"container":"ProfilePicture_container__ZkW6b"};